import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateRange } from 'src/app/shared/components/date-range.component';
import { PriceIndex, MarketService } from '../market.service';
import { DateTimeHelpers } from '../../shared/helpers/date-time.helpers';
import { saveAs } from 'file-saver';
import { MarketToolbarComponent } from '../market-toolbar/market-toolbar.component';
import moment from 'moment';
import { PgDateRangeTitleEnum, PgTitleComponent } from 'src/app/shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';

@Component({
  selector: 'app-market-list',
  templateUrl: './market-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AgGridModule],
})
export class MarketListComponent implements OnInit, PgTitleComponent{

  title: EventEmitter<string> = new EventEmitter();
  dateRangeSubTitle = new EventEmitter<[DateRange, PgDateRangeTitleEnum]>();

  toolbarComponentType = MarketToolbarComponent;
  toolbarComponent!: MarketToolbarComponent;

  selectedProvider?: string;
  dateRange: DateRange;
  prices?: PriceIndex[];

  gridOptions: GridOptions = {};

  constructor(private _activateRoute: ActivatedRoute,
    private _pricingService: MarketService,
      private _router: Router
  ) {     this.dateRange = {
    startDate: moment().subtract(12, 'months').toDate(),
    endDate: moment().toDate()
  };}

  columnDefs = [
    {
      headerName: 'Date', field: 'timestamp',
      cellRenderer: (params: any) => (params.data.timestamp) ? DateTimeHelpers.formatLocalDate(params.data.timestamp) : '',
    },
    {
      headerName: 'Persian Date', field: 'timestamp',
      cellRenderer: (params: any) => (params.data.timestamp) ? DateTimeHelpers.formatPersianLocalDate(params.data.timestamp) : '',
    },
    { headerName: 'Provider', field: 'provider'},
    { headerName: 'Index', field: 'index'},
    { headerName: 'Product', field: 'productId'},
    { headerName: 'Price', field: 'price'},
  ];

  ngOnInit() {
    this.gridOptions = AgGridService.getOptions();
    this.getParameters();
    this.toolbarComponent.date.subscribe(dateRange => {
      this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this._router
          .navigate(['pricing/list/'], {
            queryParams: {
              startTime: dateRange?.startDate.getTime(),
              endTime: dateRange?.endDate.getTime()
            }
          })
          .then((e) => console.log(`Result of Navigation is ${e}`));
      });
    });
    this.title.emit('Price List');
    this.dateRangeSubTitle.emit([
      this.dateRange,
      PgDateRangeTitleEnum.defaultTitle,
    ]);
    this.toolbarComponent.excelExporting = () => this.xlsxReport();
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  getParameters() {
    this._activateRoute.queryParams.subscribe(p => {
      const startDate = p['startTime'] ? +p['startTime'] : moment().subtract(1, 'year').toDate().getTime();
      const endDate = p['endTime'] ? +p['endTime'] : new Date() ;
      this.dateRange = {
        startDate: new Date(startDate),
        endDate: new Date(endDate)
      };
      this.toolbarComponent.dateRange = this.dateRange;
      this.title.emit('Price List');
      this.dateRangeSubTitle.emit([this.dateRange, PgDateRangeTitleEnum.defaultTitle]);
      this._pricingService.getAll(
        this.dateRange.startDate.getTime(),
        this.dateRange.endDate.getTime()).then(prices => {
        this.prices = prices;
      });
    });
  }

  xlsxReport() {
    this._pricingService.getExcelReport(
      this.dateRange.startDate.getTime(),
      this.dateRange.endDate.getTime()).subscribe(file => {
      saveAs(file.body || '', `${DateTimeHelpers.formatLocalDate(this.dateRange.startDate.getTime())}-to-` +
          `${DateTimeHelpers.formatLocalDate(this.dateRange.endDate.getTime())}-reports.xlsx`);
    });
  }
}
